import { useState } from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import Carousel from 'nuka-carousel';
import { BuyApartmentFlowPaths } from '../../routes';
import IconButton from '../icon-button';
import caretLeft from '../../assets/images/caret-left.svg';
import styles from './styles.module.scss';

export type CarouselImage = {
  src: string;
  alt?: string;
};

type ImageCarouselProps = {
  images: CarouselImage[];
  className?: string;
  topPadding?: boolean;
  isCustomSwipeIcon?: boolean;
  isCarouselInDetails?: boolean;
  isSecondary?: boolean;
  borderRadius?: number;
  onOpenBigCarousel?: (value: boolean) => void;
};

const ImageCarousel: React.FC<ImageCarouselProps> = (props) => {
  const {
    images,
    className,
    topPadding,
    isCustomSwipeIcon = false,
    isCarouselInDetails = false,
    isSecondary = false,
    borderRadius,
    onOpenBigCarousel,
  } = props;
  const navigate = useNavigate();
  const isEmpty = images.length === 0;
  const [index, setIndex] = useState(0);
  const imageHeight = 200;

  const handleLeftButton = (previousSlide: any) => {
    previousSlide();
  };

  const handleRightButton = (nextSlide: any) => {
    nextSlide();
  };

  return (
    <div className={clsx(styles.container, className)} style={{ borderRadius: borderRadius }}>
      {!isEmpty ? (
        <>
          <Carousel
            swiping={!isCustomSwipeIcon} // Disable swiping
            wrapAround
            style={{ borderRadius }}
            enableKeyboardControls={isCustomSwipeIcon}
            afterSlide={setIndex}
            disableEdgeSwiping={true}
            dragging={false}
            className={styles.carousel}
            defaultControlsConfig={{ pagingDotsStyle: { display: 'none' } }}
            renderCenterLeftControls={({ previousSlide }) =>
              images.length > 1 &&
              isCustomSwipeIcon && (
                <IconButton
                  className={styles.leftIcon}
                  icon={caretLeft}
                  onClick={() => handleLeftButton(previousSlide)}
                />
              )
            }
            renderCenterRightControls={({ nextSlide }) =>
              images.length > 1 &&
              isCustomSwipeIcon && (
                <IconButton
                  className={styles.rightIcon}
                  icon={caretLeft}
                  onClick={() => handleRightButton(nextSlide)}
                />
              )
            }
          >
            {images.map((i, idx) => (
              <img
                src={i.src}
                alt={i.alt}
                key={idx}
                height={imageHeight}
                onClick={() => {
                  if (onOpenBigCarousel) {
                    return onOpenBigCarousel(true);
                  }
                  navigate(BuyApartmentFlowPaths.image, {
                    state: {
                      src: i.src,
                      alt: i.alt,
                      images: isCarouselInDetails ? images : undefined,
                    },
                  });
                }}
              />
            ))}
          </Carousel>
          {isSecondary && <span className={styles.containerSecondaryTitle}>Вторичное жилье</span>}

          <div className={styles.pageInfo}>{index + 1 + '/' + images.length}</div>
        </>
      ) : (
        <div
          className={clsx(styles.noImages, topPadding && styles.noImagesPadded)}
          style={{ height: imageHeight }}
        >
          Изображений нет
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
